




























































import { Component, Vue } from 'vue-property-decorator'
import adminPanelApi from '@/api/admin-panel'
import {TelephonyServerATableDto} from "@/global";

@Component({
})
export default class AdminPanel_TelephonyServers extends Vue {
    table = {
        isLoading: false,
        currentPage: 1,
        totalCount: -1,

        fields: [
            {
                key: 'actions',
                label: ''
            },
            {
                key: 'type',
                label: 'Тип'
            },
            {
                key: 'name',
                label: 'Назва'
            },
            {
                key: 'serverAddress',
                label: 'Адреса серверу'
            },
            {
                key: 'robotAddressPool',
                label: 'Роботи'
            },
            {
                key: 'phoneNumbersFirstPrefix',
                label: 'Префікс СМТЗ'
            },
            {
                key: 'phoneNumbersSecondPrefix',
                label: 'Префікс організації'
            },
            {
                key: 'organizationNames',
                label: 'Організації'
            },
        ]
    };

    tableItemsProvider(ctx, callback: (items: TelephonyServerATableDto[]) => void) {
        this.table.isLoading = true;

        adminPanelApi.telephonyServersForTable(this.table.currentPage, result => {
            // sort
            for (let i = 0; i < result.items.length; i++) {
                result.items[i].organizationNames.sort();
            }

            callback(result.items);

            this.table.totalCount = result.totalCount;
            this.table.isLoading = false;
        }, errorMessage => {
            callback([]);

            this.table.isLoading = false;
        });

        return null;
    }
}
